import React, { useState } from "react";
import Layout from "../../shared/components/organisms/layout/layout";
import SEO from "../../shared/components/atoms/seo/seo";
import siteUrl from "../../shared/utils/siteUrl";
import SectionInfoSale from "../organisms/section-info-sale/section-info-sale";
import SectionMoreSales from "../organisms/section-more-sales/section-more-sales";
import SectionInfoSaleInactive from "../organisms/section-info-sale-inactive/section-info-sale-inactive";

const TemplateSale = (props) => {
  const { pageContext } = props;
  const { slug } = pageContext;

  return (
    <Layout>
      <SEO
        title={pageContext.metaTitulo}
        image={pageContext.metaImagen && pageContext.metaImagen.file.url}
        description={pageContext.metaDescripcion}
        slug={siteUrl + "/bienes-en-venta/" + slug + "/"}
        meta={[
          {
            name: "robots",
            content: "index, follow",
          },
        ]}
      />
      {pageContext.disponible ? (
        <>
          <SectionInfoSale sale={pageContext} />
          <SectionMoreSales sale={pageContext} />
        </>
      ) : (
        <SectionInfoSaleInactive sale={pageContext} />
      )}
    </Layout>
  );
};

export default TemplateSale;
